import $ from 'jquery'
const scroll = {
  init () {
    let $sliderPre = $('.J_gamepic_left');
    let $sliderNext =  $('.J_gamepic_right');
    let timerCarousel
    let imgCount = $('.slide .item').length
    let currImg = 0
    // 自动轮播
    timerCarousel = setInterval(function () {
        currImg += 1
        if (currImg === imgCount) {currImg = 0}
        $('.slide .item').eq(currImg).fadeIn().siblings().fadeOut()
        $('.J_gamepic_pagination a').eq(currImg).addClass('active').siblings().removeClass('active')
    }, 3000)
    // 导航
    $('.J_gamepic_pagination').on('click', 'a', function() {
        clearInterval(timerCarousel)
        let currIndex = $(this).index()
        $(this).addClass('active').siblings().removeClass('active')
        $('.slide .item').eq(currIndex).fadeIn().siblings().fadeOut()     
        currImg = currIndex
        timerCarousel = setInterval(function () {
            currImg += 1
            if (currImg === imgCount) {currImg = 0}
            $('.slide .item').eq(currImg).fadeIn().siblings().fadeOut()
            $('.J_gamepic_pagination a').eq(currImg).addClass('active').siblings().removeClass('active')
        }, 3000)
    })
    // 下一张
    $sliderNext.click(function () {
        clearInterval(timerCarousel)
        currImg += 1
        if (currImg === imgCount) {currImg = 0}
        $('.slide .item').eq(currImg).fadeIn().siblings().fadeOut()
        $('.J_gamepic_pagination a').eq(currImg).addClass('active').siblings().removeClass('active')
        timerCarousel = setInterval(function () {
            currImg += 1
            if (currImg === imgCount) {currImg = 0}
            $('.slide .item').eq(currImg).fadeIn().siblings().fadeOut()
            $('.J_gamepic_pagination a').eq(currImg).addClass('active').siblings().removeClass('active')
        }, 3000)
    });
    // 上一张
    $sliderPre.click(function () {
        clearInterval(timerCarousel)
        currImg -= 1
        if (currImg === -1) {currImg = imgCount}
        $('.slide .item').eq(currImg).fadeIn().siblings().fadeOut()  
        $('.J_gamepic_pagination a').eq(currImg).addClass('active').siblings().removeClass('active')
        timerCarousel = setInterval(function () {
            currImg += 1
            if (currImg === imgCount) {currImg = 0}
            $('.slide .item').eq(currImg).fadeIn().siblings().fadeOut()
            $('.J_gamepic_pagination a').eq(currImg).addClass('active').siblings().removeClass('active')
        }, 3000)
    });
  }
}
module.exports = scroll